import * as React from 'react';
import debounce from 'lodash.debounce';
import { isMobile } from 'src/utils/responsiveHelpers';

import Filter from './components/Filter';
import Brand from './components/Brand';
import Subcategory from './components/Subcategory';
import MobileFilterMenu from './components/MobileFilterMenu';
import MobileSubcategoriesSelect from './components/MobileSubcategoriesSelect';
import {categoryUrl } from 'src/utils/navigation';
import './CategoriesFilter.scss';
import SubcategoryModel from 'src/model/subcategory.model';
import { goToCategory } from 'src/utils/navigation';
import SubcategoryFilter from 'src/model/subcategoryFilter.model';
import SubcategoryBrandFilter from 'src/model/subcategoryBrandFilter.model';
import ExpandableScroll from './components/Subcategory/ExpandableScroll';

export default class CategoriesFilter extends React.Component<
  ICategoriesFilterProps,
  ICategoriesFilterState
> {
  private resizeEvent: any;

  constructor(props: any) {
    super(props);

    this.state = {
      isMobile: isMobile(),
      mobileMenuOpened: false
    };

    this.resizeEvent = debounce(() => {
      this.setState({ isMobile: isMobile() });
    }, 700);
  }

  private closeMobileMenu = () => {
    this.setState({ mobileMenuOpened: false });
    this.props.handleScroll(true);
  };

  private openMobileMenu = () => {
    this.setState({ mobileMenuOpened: true });
    this.props.handleScroll(false);
  };

  private cancelFilter = () => {
    this.clearFilter();
    this.closeMobileMenu();
  };

  private clearFilter = () => {
    this.props.clearFilters([]);
  };

  private selectSubcategory = (subcategoryId: number) => {
    this.clearFilter();
    setTimeout(() => {
      goToCategory(this.props.match.params.categoryId, subcategoryId);
    }, 200);
  };

  private brandList = () => {
    const products = this.props.products;
    const uniqueProducts = products.filter((product:any, index:any, self:any) =>
      index === self.findIndex((p:any) => p.manufacturerCode === product.manufacturerCode)
    );
    // Map unique products to the desired structure
    const brandArr = uniqueProducts.map((product:any, index:any) => ({
      id: index + 1,
      name: product.manufacturerCode,
      filterType: 'brand'
    }));

    return brandArr;
  };    

  /*
			getActiveSubcategory: return the active subcategory id or object
		 */
  private getActiveSubcategory = (target: 'id' | 'object') => {
    if (target === 'id') {
      return this.props.match.params.subcategoryId;
    } else {
      return this.props.subcategories[this.props.match.params.subcategoryId];
    }
  };

  private renderSubcategories = () => {
    
    if (this.props.subcategories.length !== 0) {
      return this.props.subcategories
        .sort((a, b) => (a.name > b.name ? 1 : -1))
        .map((item: SubcategoryModel, index: number) => {
        return (
            <Subcategory
              key={index}
              active={Number(this.props.match.params.subcategoryId) === item.id}
              action={this.selectSubcategory}
              subcategory={item}
            />
          );
        });
    } else {
      return (
        <div className="categories-filters--loading">
          <span className="loading-item large" />
          <span className="loading-item large" />
          <span className="loading-item large" />
          <span className="loading-item large" />
          <span className="loading-item large" />
          <span className="loading-item large" />
        </div>
      );
    }
  };

  private renderFilters = (t: any) => {
    if (this.props.filtersPending === false) {
      if (this.props.filters.length !== 0) {
        const { filters, activeFilters } = this.props;
        const filtersNodes = filters.map((item: any, index: number) => {
          const activeFilterIndex = activeFilters.findIndex(
            (filter: SubcategoryFilter) => {
              return filter === item;
            }
          );
          const isActive = activeFilterIndex !== -1 ? true : false;
          return (
            <Filter
              key={index}
              indexKey={index}
              active={localStorage.getItem('applianceSelectedCategoryName') === null ? isActive : localStorage.getItem('applianceSelectedCategoryName')===item.name}
              filter={item}
              selectionType='filter'
              action={(
                subcategoryFilter: SubcategoryFilter,
                action: 'add' | 'remove',selectiontype:any
              ) => {
                this.handleSetFilter(subcategoryFilter, action,selectiontype);
              }}
            />
          );
        });
        return (
          <React.Fragment>
            <p className="filter-title">{t('categories.filterBy')}:</p>
            <ExpandableScroll>
               <ul>{filtersNodes}</ul>
             </ExpandableScroll>
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment>
            <p className="filter-title">{t('categories.filterBy')}:</p>
            <p className="no-filters">{t('categories.noFilters')}</p>
          </React.Fragment>
        );
      }
    } else {
      return (
        <React.Fragment>
          <p className="filter-title">{t('categories.filterBy')}:</p>
          <div className="categories-filters--loading">
            <span className="loading-item large" />
            <span className="loading-item large" />
            <span className="loading-item large" />
          </div>
        </React.Fragment>
      );
    }
  };

  private renderBrands = (t: any) => {
    const brandArr = this.props.brands;
    if (this.props.filtersPending === false) {
      if (brandArr.length !== 0) {
        const { filters, activeFilters } = this.props; 
        const BrandsNodes = brandArr.map((item: any, index: number) => {
          const activeFilterIndex = activeFilters.findIndex(
            (filter: SubcategoryBrandFilter) => filter.manufacturerCode === item.manufacturerCode && filter.id === item.id
          );
          const isActive = activeFilterIndex !== -1 ? true : false;
          return (
            <Brand
              key={index}
              indexKey={index}
              active={isActive}
              brand={item}
              brandName={item}
              selectionType='brand'
              action={(
                subcategoryBrandFilter: SubcategoryBrandFilter,
                action: 'add' | 'remove',selectiontype:any
              ) => {
                this.handleSetBrandFilter(subcategoryBrandFilter, action,selectiontype);
              }}
            />
          );
        });
        return (
          <React.Fragment>
            <p className="filter-title">{t('categories.brandBy')}:</p>
              <ExpandableScroll>
                 <ul className="filter-title-scroll">{BrandsNodes}</ul>
              </ExpandableScroll>
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment>
            <p className="filter-title">{t('categories.brandBy')}:</p>
            <p className="no-filters">{t('categories.noBrands')}</p>
          </React.Fragment>
        );
      }
    } else {
      return (
        <React.Fragment>
          <p className="filter-title">{t('categories.brandBy')}:</p>
          <div className="categories-filters--loading">
            <span className="loading-item large" />
            <span className="loading-item large" />
            <span className="loading-item large" />
          </div>
        </React.Fragment>
      );
    }
  };

  private setSelectedSubcategory = () => {
    return this.props.selectedSubcategory
      ? this.props.selectedSubcategory.name
      : '';
  };

  /* handleSetFilter: Sets fiter and decides if get filtered products or no

		 */
  private handleSetFilter = (
    subcategoryFilter: SubcategoryFilter,
    action: 'add' | 'remove',selectiontype:any
  ) => {
    localStorage.removeItem("applianceSelectedCategoryName");
    this.props.setFilters(subcategoryFilter, action,selectiontype);
  };  

  private handleSetBrandFilter = (
    subcategoryBrandFilter: SubcategoryBrandFilter,
    action: 'add' | 'remove',selectiontype:any
  ) => {
    this.props.setFilters(subcategoryBrandFilter, action,selectiontype);
  };

  private handleSaveFilters = () => {
    
    if (this.state.isMobile) {
      if (this.props.activeFilters.length !== 0) {
        this.props.getFilteredProducts(
          this.props.selectedSubcategory.id.toString(),
          this.props.activeFilters,
          this.props.selectiontype
        );
      }
      this.closeMobileMenu();
      const el = document.querySelector(".rp-categories-page--content");
        if (!el) { return; }
        // Option A: smooth scroll window to that element’s top
        const offset = el.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: offset, behavior: "smooth" });
    }
  };

  private handleSamePageClick(
    e: React.MouseEvent<HTMLAnchorElement>,
    href: string,
    categoryId?: number,
    subcategoryId?: number
  ): void {
    const current = window.location.pathname + window.location.search + window.location.hash;
    const u = new URL(href, window.location.origin);
    const target = u.pathname + u.search + u.hash;
  
    // Same URL → force a hard refresh
    if (current === target) {
      e.preventDefault();
      window.location.reload();
      return;
    }
  
    // Different URL → navigate programmatically (or let the <a> do it)
    if (categoryId != null && subcategoryId != null) {
      e.preventDefault(); // prevent default if you programmatically navigate
      categoryUrl(categoryId, subcategoryId); // your app's navigation
      return;
    }
  
    // else: do nothing → allow the <a href> to navigate normally
  }

  public componentDidMount = () => {
    window.addEventListener('resize', this.resizeEvent);
  };

  public componentWillUnmount = () => {
    window.removeEventListener('resize', this.resizeEvent);
  };

  public render() {
    const { t } = this.props;
    const mobileMenuClass = this.state.mobileMenuOpened ? 'opened' : 'closed';
    const breadcrumbCategory = this.setSelectedSubcategory().toString();
    const  cateItem =  this.props.subcategories;
    const parentCategoryName = cateItem?.[0]?.category?.name ?? "";
    const parentCategoryId = cateItem?.[0]?.category?.id ?? 0;
    const subCatId = cateItem?.[0]?.id ?? 0;

    return (
      <React.Fragment>
        <div className="categories-filters--mobile-filters no-select">
          <nav className="categories-filters---mobile-header">
            <div className="breadcrumbs">
        {t("common.home")}
            <span> / </span>
            <span>{parentCategoryName}</span>
            <span> / </span>
            <a
              href={categoryUrl(parentCategoryId, subCatId)}
              onClick={(e) =>
                this.handleSamePageClick?.(
                  e,
                  categoryUrl(parentCategoryId, subCatId),
                  parentCategoryId, subCatId
                )
              }
              style={{ textDecoration: "none", color: "#0d872e" }}
            >
          {breadcrumbCategory}
        </a>
            </div>
            <div className="filter-by" onClick={this.openMobileMenu}>
              {t('common.filterBy')}
            </div>
          </nav>
          <div>
            <MobileSubcategoriesSelect
              subcategories={this.props.subcategories}
              activeSubcategory={this.getActiveSubcategory('id')}
              isLoading={this.props.isLoadingSubcategories}
              changeSubcategory={this.selectSubcategory}
            />
          </div>
          <MobileFilterMenu
            closeMenu={this.closeMobileMenu}
            handleSaveFilters={this.handleSaveFilters}
            menuIsOpened={this.state.mobileMenuOpened}
            clear={this.clearFilter}
            cancel={this.cancelFilter}
          >
            {this.props.brands.length !== 0 && (
               <div className="content-filters">{this.renderBrands(t)}</div>
            )} 
            {this.props.filters.length !== 0 && (  
                <>                
                 <hr className="hrLine" />
                 <div className="content-filters">{this.renderFilters(t)}</div>
                </>   
              )}

            {this.props.subcategories.length !== 0 && (  
                <>
                  <hr className="hrLine" />
                  <div className="content-filters">
                    <p className="filter-title">{t('categories.subcategories')}:</p>
                    
                      <ExpandableScroll>
                        <div className="content-filters--subcategories">
                          {this.renderSubcategories()}                            
                        </div>                        
                        </ExpandableScroll>
                  </div> 
                 </>
               )}
            
          </MobileFilterMenu>
        </div>

        <div className="categories-filters roboto categories-filters--desktop-filters no-select">
          <div className={`categories-filters--content ${mobileMenuClass}`}>
            <div className="filters-header">
              <i
                className="rpds-backspace back"
                onClick={this.closeMobileMenu}
              />
              <p className="text">{t('common.backToResults')}</p>
            </div>

            <div className="filters-mobile-content">
              <div className="content-nav">
                <p className="cancel" onClick={this.cancelFilter}>
                  {t('common.cancel')}
                </p>
                <p className="filter-by">{t('common.filterBy')}:</p>
                <p className="clear" onClick={this.clearFilter}>
                  {t('common.clear')}
                </p>
              </div>
               {this.props.brands.length !== 0 && (
               <div className="content-filters">{this.renderBrands(t)}</div>
              )}                  
              
              {this.props.filters.length !== 0 && (  
                <>                
                 <hr className="hrLine" />
                 <div className="content-filters">{this.renderFilters(t)}</div>
                </>   
              )}
              {this.props.subcategories.length !== 0 && (  
                <>
                  <hr className="hrLine" />
                  <div className="content-filters">
                    <p className="filter-title">{t('categories.subcategories')}:</p>
                    
                      <ExpandableScroll>
                        <div className="content-filters--subcategories">
                          {this.renderSubcategories()}                            
                        </div>                        
                        </ExpandableScroll>
                  </div> 
                 </>
               )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

interface ICategoriesFilterProps {
  handleScroll(shouldScroll: boolean): void;
  setFilters(
    subcategoryFilter: SubcategoryFilter,
    action: 'add' | 'remove',selectiontype:any
  ): void;
  
  clearFilters(filters: any[]): void;
  getFilteredProducts(
    id: string,
    filters: SubcategoryFilter[],
    selectiontype: string,
    pageNumber?: number
  ): any;
  t: any;
  activeSubcategory: number;
  filters: SubcategoryFilter[];
  brands: SubcategoryBrandFilter[];
  activeFilters: SubcategoryFilter[];  
  selectiontype: string;
  filtersPending: boolean;
  match: any;
  subcategories: SubcategoryModel[];
  selectedSubcategory: SubcategoryModel;
  isLoadingSubcategories: boolean;
  products: any;
}

interface ICategoriesFilterState {
  isMobile: boolean;
  mobileMenuOpened: boolean;
}
